import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateTextosModificats } from '../../actions/configFormularioAction';
import { useTranslation } from "react-i18next";
import { uiActualizarTextosStateAction } from '../../actions/ui';

const IconSave = () => (
  <svg width="15" height="15" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M17 3H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V7l-4-4zm-5 16a3 3 0 110-6 3 3 0 010 6zm3-10H5V5h10v4z"/>
  </svg>
);

export const ComponenteFormularioTexto = ({ catIndex }) => {
  const dispatch = useDispatch();
  const [t] = useTranslation("generic");
  const { auth, configFormulario, ui } = useSelector((state) => state);
  const { infoFormularioTextCategoria } = configFormulario;

  const [editableQuestions, setEditableQuestions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const keyFilter   = ui.textosState === 2 ? 'Prog' : 'Preg';
    const categoryKey = `Categoria${catIndex}`;
    const categoryData = infoFormularioTextCategoria[categoryKey] || {};

    const initialQuestions = Object.keys(categoryData)
      .filter((key) => key.includes(keyFilter))
      .map((key) => ({ id: key, type: 'text', value: categoryData[key] || '' }));

    const desplegables = ui.textosState === 1 ? Object.keys(categoryData)
      .filter((key) => key.includes('Desplegable'))
      .map((key) => {
        const desplegableNumber = key.match(/Desplegable(\d+)/)?.[1];
        const relatedQuestion   = initialQuestions.find((question) => {
          const questionNumber = question.id.match(/Cat\d+_Preg(\d+)/)?.[1];
          return questionNumber === desplegableNumber;
        });
        return { id: key, type: 'dropdown', value: categoryData[key] || '', relatedQuestion: relatedQuestion?.id || null };
      }) : [];

    const relatedDesplegables = desplegables.filter((d) => d.relatedQuestion !== null).reverse();
    const finalDesplegables   = desplegables.filter((d) => d.id.includes('DesplegableX')).reverse();

    const questionsWithDesplegables = initialQuestions.reduce((acc, question) => {
      acc.push(question);
      relatedDesplegables.filter((d) => d.relatedQuestion === question.id).forEach((d) => acc.push(d));
      return acc;
    }, []);

    const finalList = [...questionsWithDesplegables, ...finalDesplegables];
    const title     = ui.textosState === 1 ? categoryData[`Cat${catIndex}_Titol`] || '' : '';
    const questionsWithTitle = title
      ? [{ id:`Cat${catIndex}_Titol`, type:'title', value:title }, ...finalList]
      : finalList;

    setEditableQuestions(questionsWithTitle);
    setLoading(false);
  }, [infoFormularioTextCategoria, ui.textosState, catIndex]);

  const handleQuestionChange = (id, val) => {
    setEditableQuestions(editableQuestions.map((q) => q.id === id ? { ...q, value: val } : q));
  };

  const handleModificarTextos = () => {
    const dataToSend  = {};
    const categoryKey = `Categoria${catIndex}`;
    editableQuestions.forEach((question) => {
      if (infoFormularioTextCategoria[categoryKey][question.id] !== question.value) {
        dataToSend[question.id] = question.value;
      }
    });
    if (Object.keys(dataToSend).length > 0) {
      dispatch(uiActualizarTextosStateAction(2));
      dispatch(updateTextosModificats(auth.tokenJwt, dataToSend, categoryKey));
    }
  };

  if (loading) return <div style={{ padding:'24px 20px', color:'#9ca3af', fontSize:14 }}>Cargando...</div>;

  // Agrupar preguntas con sus desplegables
  const secciones = [];
  editableQuestions.forEach((q) => {
    if (q.type === 'title') {
      secciones.push({ tipo: 'titulo', item: q });
    } else if (q.type === 'dropdown' && q.id.includes('DesplegableX')) {
      secciones.push({ tipo: 'seccion_desplegable_comun', item: q });
    } else if (q.type === 'dropdown') {
      if (secciones.length && secciones[secciones.length-1].tipo === 'pregunta') {
        secciones[secciones.length-1].desplegables = secciones[secciones.length-1].desplegables || [];
        secciones[secciones.length-1].desplegables.push(q);
      }
    } else {
      secciones.push({ tipo: 'pregunta', item: q, desplegables: [] });
    }
  });

  return (
    <div style={{ padding:'20px 24px' }}>
      <div style={{ display:'flex', flexDirection:'column', gap:10 }}>
        {secciones.map((sec, idx) => {

          if (sec.tipo === 'titulo') {
            return (
              <div key={sec.item.id}>
                <p className="ft-seccion-label">Título de categoría</p>
                <CampoTexto
                  item={sec.item}
                  original={getOriginal(infoFormularioTextCategoria, catIndex, sec.item.id)}
                  onChange={handleQuestionChange}
                  rows={2}
                />
              </div>
            );
          }

          if (sec.tipo === 'pregunta') {
            const numPreg = sec.item.id.match(/Preg(\d+)/)?.[1] || idx;
            const changed = sec.item.value !== getOriginal(infoFormularioTextCategoria, catIndex, sec.item.id);
            return (
              <div key={sec.item.id} style={{ border:`1.5px solid ${changed?'#f59e0b':'#f3f4f6'}`, borderRadius:10, overflow:'hidden', background: changed?'#fffbeb':'#fff' }}>
                {/* Cabecera pregunta */}
                <div style={{ display:'flex', alignItems:'center', gap:8, padding:'8px 14px', background: changed?'#fef9c3':'#f9fafb', borderBottom:'1px solid #f3f4f6' }}>
                  <span style={{ width:22, height:22, borderRadius:6, background:'#374151', color:'#fff', display:'inline-flex', alignItems:'center', justifyContent:'center', fontSize:11, fontWeight:700, flexShrink:0 }}>
                    {numPreg}
                  </span>
                  <span style={{ fontSize:11, fontWeight:700, color:'#6b7280', textTransform:'uppercase', letterSpacing:'0.06em' }}>
                    {ui.textosState === 2 ? 'Programa' : 'Pregunta'} {numPreg}
                    {changed && <span style={{ marginLeft:8, color:'#d97706' }}>· Modificado</span>}
                  </span>
                </div>
                <div style={{ padding:'12px 14px' }}>
                  <CampoTexto
                    item={sec.item}
                    original={getOriginal(infoFormularioTextCategoria, catIndex, sec.item.id)}
                    onChange={handleQuestionChange}
                    rows={3}
                  />
                  {sec.desplegables?.length > 0 && (
                    <div style={{ marginTop:10, paddingTop:10, borderTop:'1px dashed #e5e7eb' }}>
                      <p className="ft-seccion-label" style={{ marginBottom:8 }}>Opciones desplegable</p>
                      <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
                        {sec.desplegables.map((d, di) => (
                          <CampoTexto
                            key={d.id}
                            item={d}
                            original={getOriginal(infoFormularioTextCategoria, catIndex, d.id)}
                            onChange={handleQuestionChange}
                            rows={1}
                            placeholder={`Opción ${di + 1}`}
                            indent
                          />
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            );
          }

          if (sec.tipo === 'seccion_desplegable_comun') {
            return (
              <div key={sec.item.id}>
                <p className="ft-seccion-label">Desplegable común</p>
                <CampoTexto
                  item={sec.item}
                  original={getOriginal(infoFormularioTextCategoria, catIndex, sec.item.id)}
                  onChange={handleQuestionChange}
                  rows={1}
                />
              </div>
            );
          }

          return null;
        })}
      </div>

      <div style={{ marginTop:20, paddingTop:16, borderTop:'1px solid #f3f4f6' }}>
        <button onClick={handleModificarTextos} className="u-btn-primary">
          <IconSave /> Guardar nuevos textos
        </button>
      </div>
    </div>
  );
};

// ── Helper ────────────────────────────────────────────────────────────────────
function getOriginal(infoFormularioTextCategoria, catIndex, id) {
  return infoFormularioTextCategoria?.[`Categoria${catIndex}`]?.[id] ?? '';
}

// ── Campo de texto unificado ──────────────────────────────────────────────────
const CampoTexto = ({ item, original, onChange, rows = 3, placeholder, indent = false }) => {
  const changed = item.value !== original;
  return (
    <textarea
      value={item.value}
      rows={rows}
      placeholder={placeholder || ''}
      onChange={e => onChange(item.id, e.target.value)}
      className="fa-nivel-textarea"
      style={{
        borderColor: changed ? '#f59e0b' : '#e5e7eb',
        background:  changed ? '#fffbeb' : '#fff',
        marginLeft:  indent ? 8 : 0,
        width:       indent ? 'calc(100% - 8px)' : '100%',
      }}
    />
  );
};